import React, { useEffect, useState } from "react";
import { getFirestore, doc, onSnapshot, getDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Lobby } from "../interfaces/lobby";
import { Game } from "../interfaces/game";
import ResetEloButton from "./ResetEloButton";

function DebugPage() {
  const { lobbyId } = useParams();
  const [lobbyState, setLobbyState] = useState<Lobby | null>(null);
  const [gameState, setGameState] = useState<Game | null>(null);
  // eslint-disable-next-line
  const [userObjects, setUserObjects] = useState<any[]>([]); // Change the type to match your user object type

  useEffect(() => {
    if (!lobbyId) return;
    const tempDb = getFirestore();
    const lobbyDocRef = doc(tempDb, "lobbies", lobbyId);

    const unsubscribe = onSnapshot(lobbyDocRef, async (docSnapshot) => {
      if (docSnapshot.exists()) {
        const lobbyData = docSnapshot.data() as Lobby;
        setLobbyState(lobbyData);
        const gameId = lobbyData?.gameId;
        const gameDocRef = doc(tempDb, "games", gameId);

        const gameUnsubscribe = onSnapshot(gameDocRef, (gameDocSnapshot) => {
          if (gameDocSnapshot.exists()) {
            const gameData = gameDocSnapshot.data() as Game;
            setGameState(gameData);
          }
        });

        const userObjectsPromises = lobbyData.players.map(async (userId) => {
          const userDocRef = doc(tempDb, "users", userId!);
          const userDocSnapshot = await getDoc(userDocRef);
          if (userDocSnapshot.exists()) {
            return { userId, ...userDocSnapshot.data() };
          }
          return null;
        });

        const userObjectsData = await Promise.all(userObjectsPromises);
        setUserObjects(
          userObjectsData.filter((userObject) => userObject !== null),
        );

        return () => {
          gameUnsubscribe();
        };
      }
      return null;
    });

    // eslint-disable-next-line
    return unsubscribe;
  }, [lobbyId]);

  if (!lobbyId) {
    return null;
  }

  return (
    <Grid container spacing={2} style={{ color: "white" }}>
      <Grid item xs={12}>
        <ResetEloButton />
        <h1>Debug Page</h1>
        <p>Lobby ID: {lobbyId}</p>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="h6" gutterBottom>
          Lobby
        </Typography>
        <pre>{JSON.stringify(lobbyState, null, 2)}</pre>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="h6" gutterBottom>
          Game
        </Typography>
        <pre>{JSON.stringify(gameState, null, 2)}</pre>
      </Grid>
      <Grid item xs={4}>
        <Typography variant="h6" gutterBottom>
          Users
        </Typography>
        <pre>{JSON.stringify(userObjects, null, 2)}</pre>
      </Grid>
    </Grid>
  );
}

export default DebugPage;
